<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="`/${record_url}`">{{  (contact.record_type.charAt(0).toUpperCase() + contact.record_type.slice(1)) }}</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contact.record_id && contact.record_name">
                        <router-link :to="`/${record_url}/view/${contact.record_id}`">{{ contact.record_name }}</router-link>
                    </li>
                    <template v-if="!contact.id">
                        <vue-headful :title="'Create Contact - AMOS365'" />
                        <li class="breadcrumb-item active" aria-current="page">Create Contact</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Contact] ' + contact.first_name + ' '+contact.last_name+' - AMOS365'" />
                        <li class="breadcrumb-item active" aria-current="page">Edit Contact: {{ contact.first_name }} {{ contact.last_name }}</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ contact.first_name }} {{ contact.last_name }}</span>
                <span v-else>New Contact</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.first_name, 'text-muted-no': !errors.first_name}">
                                    First Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contact.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="contact.first_name" :class="{'form-control': true, 'is-invalid': errors.first_name}" placeholder="Enter Contact First Name" />

                                    <div class="text-danger mt-2" v-if="errors.first_name">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.first_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.last_name, 'text-muted-no': !errors.last_name}">
                                    Last Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contact.last_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="contact.last_name" :class="{'form-control': true, 'is-invalid': errors.last_name}" placeholder="Enter Contact Last Name" />

                                    <div class="text-danger mt-2" v-if="errors.last_name">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.last_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.title, 'text-muted-no': !errors.title}">Title:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="contact.title" :class="{'form-control': true, 'is-invalid': errors.title}" placeholder="Enter Contact Title" />

                                    <div class="text-danger mt-2" v-if="errors.title">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.title">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Contact Type:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.record_type, 'text-muted-no': !errors.record_type}">
                                    Contact Type: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contact.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-radio-group v-model="contact.record_type" :options="recordTypeOptions" name="record_type" plain></b-form-radio-group>

                                    <div class="text-danger mt-2" v-if="errors.record_type">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.record_type">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="contact.record_type">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.record_id, 'text-muted-no': !errors.record_id}">
                                    {{ contact.record_type }}: <i class="fa fa-sm fa-asterisk text-danger" v-if="!contact.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <v-select
                                        v-model="contact.record_id"
                                        :options="recordIdOptions"
                                        :reduce="record => record.id"
                                        :label="typeahead_name"
                                        :class="{'is-invalid': errors.record_id}"
                                        :placeholder="`-- Select an ${contact.record_type} --`"
                                        @search="searchRecords"
                                        :filterable="false" />

                                    <div class="text-danger mt-2" v-if="errors.record_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.record_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Email ({{ emails.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.emailEditor.addEmail()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <email-editor ref="emailEditor" :emails="emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Phone Numbers ({{ phones.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.phoneEditor.addPhone()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <phone-editor ref="phoneEditor" :phones="phones" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Address ({{ addresses.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.addressEditor.addAddress()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <address-editor ref="addressEditor" :addresses="addresses" :states="states" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveContact()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveContact()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                contact: {},
                errors: {},
                states: [],
                addresses: [],
                emails: [],
                phones: [],
                recordsWithContacts: [],
                recordIdOptions: [],
            }
        },

        watch: {
            'contact.record_type'(newval, oldVal){
                //Do nothing if the old value was null
                //That means it was set from the AJAX request
                if(!oldVal)
                {
                    return;
                }

                //Reset the options
                this.recordIdOptions = [];

                //Reset the ID
                this.contact.record_id = null;
            }
        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },

            recordTypeOptions(){
                //Setup
                var options = [];

                //Main Loop
                for(var i = 0; i < this.recordsWithContacts.length; i++)
                {
                    options.push({value: this.recordsWithContacts[i], text: this.recordsWithContacts[i]});
                }

                //Send it
                return options;
            },


            typeahead_name(){
                //Check for Null
                if(!this.contact.record_type)
                {
                    return null;
                }

                //SEnd it
                return this.contact.record_type.toLowerCase() + '_name';
            },

            record_url(){
                //Check for Null
                if(!this.contact.record_type)
                {
                    return null;
                }

                //Helpers Based on the Record Type
                var key = this.contact.record_type.toLowerCase();
                var url = key + 's';

                //Handler
                switch(this.contact.record_type)
                {
                    //Customer Stuff
                    case 'Agency':
                        url = 'agencies';
                        break;
                }

                //SEnd it
                return url;
            }
        },

        methods: {

            getContact(){
                //Send it
                this.$http.get('/contacts/edit' + (this.id ? '/'+this.id : ''), this.$route.query)
                    .then(response => {
                        //Set the contact
                        this.contact = response.data.contact;
                        this.addresses = response.data.addresses;
                        this.emails = response.data.emails;
                        this.phones = response.data.phones;
                        this.states = response.data.states;
                        this.recordsWithContacts = response.data.recordsWithContacts;

                        //Check for Record Type and Name
                        if(this.contact.record_name)
                        {
                            //Build the Payloda
                            var option = {id: this.contact.record_id};

                            //Push using the key
                            option[this.typeahead_name] = this.contact.record_name;

                            //Push
                            this.recordIdOptions.push(option);
                        }
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveContact(){
                //Helpers
                this.saving = true;

                //Reset ERror
                this.errors = {};
                this.$refs.emailEditor.setErrors({});
                this.$refs.phoneEditor.setErrors({});
                this.$refs.addressEditor.setErrors({});

                //Append Stuff to the Payload
                this.contact.emails = this.$refs.emailEditor.getEmails();
                this.contact.phones = this.$refs.phoneEditor.getPhones();
                this.contact.addresses = this.$refs.addressEditor.getAddresses();

                //Send it
                this.$http
                .post('contacts/save', this.contact)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Contact ' + (this.contact.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/'+this.record_url+'/view/' + response.data.record_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the errors for the component editors
                        this.$refs.emailEditor.setErrors(this.errors);
                        this.$refs.phoneEditor.setErrors(this.errors);
                        this.$refs.addressEditor.setErrors(this.errors);
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Contact');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            searchRecords(search, loading){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Helpers Based on the Record Type
                var orderBy =  this.record_url + '.' + this.typeahead_name;

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: orderBy,
                    typeahead: true,
                };

                //Show a Loading INdicator?
                this.$http.get('/'+this.record_url, payload)
                        .then(response => {
                            //Turn off loading
                            loading(false);

                            // //Set the values
                            this.recordIdOptions = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        });
            }

        },

        mounted() {
            //get the contact?
            this.getContact();
        }
    }
</script>
